import { config } from '$lib/config';
import axios from 'axios';

export const api_client = axios.create({ baseURL: config.api.api_endpoint });
